// ===== FIXED AUTHORIZED USER LAYOUT =====
// src/Layout/AuthorisedUser/index.jsx
import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";
import NavigationBar from "./NavigationBar";
import Header from "./Header";
import Footer from "./Footer";
import { useAuth } from "../../hooks/useAuth";
import { DASHBOARD_URL } from "constants/app";
import { fetchuserProfile } from "service/Auth.services";
import { useSession } from "hooks/useSession";



const AuthorisedUser = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const {userid, role,isLogin} = useSession();
  // useEffect(() => {
  //   const checkAuth = async () => {
  //     // const isLogin = localStorage.getItem("islogin");
  //     // const role = localStorage.getItem("role");

  //     // if (!isLogin || !role) {
  //     //   navigate("/login", { replace: true });
  //     //   return;
  //     // }

  //     try {
  //       // debugger;
  //       const profile = await fetchuserProfile(userid);
        

  //       if (profile?.kyc !== "active") {
  //         navigate("/complete_your_registration", { replace: true }); // 🚨 force KYC page
  //         return;
  //       }

  //       // If on root or login page → send to role-based dashboard
  //       if (location.pathname === "/" || location.pathname === "/login") {
  //         if (DASHBOARD_URL[role]) {
  //           navigate(DASHBOARD_URL[role], { replace: true });
  //         } else {
  //           navigate("/", { replace: true });
  //         }
  //       }
  //     } catch (err) {
  //       console.error("Profile fetch failed", err); 
  //       navigate("/login", { replace: true });
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   checkAuth();
  // }, [navigate, location]);
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const profile = await fetchuserProfile(userid);
  
        if (profile?.kyc !== "active") {
          navigate("/complete_your_registration", { replace: true });
          return;
        }
  
        if (location.pathname === "/" || location.pathname === "/login") {
          if (DASHBOARD_URL[role]) {
            navigate(DASHBOARD_URL[role], { replace: true });
          } else {
            navigate("/", { replace: true });
          }
        }
      } catch (err) {
        console.error("Profile fetch failed", err);
        navigate("/login", { replace: true });
      } finally {
        setLoading(false);
      }
    };
  
    checkAuth();
  }, [location.pathname, navigate]);
  

  return (
    <div className="app-wrapper">
      {/* Loader */}
      <div className="loader-wraper">
        <div className="app-loader">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      {/* Navigation */}
      <NavigationBar />

      {/* Content */}
      <div className="app-content">
        <Header />

        {/* Main Content - Different pages will be rendered here */}
        <Outlet />

        {/* Go to top button */}
        <div className="go-top">
          <span className="progress-value">
            <i className="iconoir-nav-arrow-up"></i>
          </span>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default AuthorisedUser;
